import { render, staticRenderFns } from "./AdvisorsList.vue?vue&type=template&id=5d7efc85"
import script from "./AdvisorsList.vue?vue&type=script&lang=js"
export * from "./AdvisorsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports